import { c as _c } from "react/compiler-runtime";
import { useMemo, type FC } from "react";
import { useSearchParams } from "next/navigation";
import { useFiles } from "~/client/services/data/files/hooks";
import { useFlashcardSets } from "~/client/services/data/flashcard-sets/hooks";
import { useNotes } from "~/client/services/data/notes/hooks";
import { useQuizzes } from "~/client/services/data/quizzes/hooks";
import { WorkspaceItem, type WorkspaceItemProps } from "./WorkspaceItem";
interface WorkspaceContentProps {
  readonly folderId?: string;
}
export const WorkspaceContent: FC<WorkspaceContentProps> = t0 => {
  const $ = _c(21);
  const {
    folderId: t1
  } = t0;
  const folderId = t1 === undefined ? null : t1;
  const searchParams = useSearchParams();
  const resources = searchParams?.get("resources");
  const t2 = !!(resources && !resources.includes("files"));
  let t3;
  if ($[0] !== folderId || $[1] !== t2) {
    t3 = {
      folderId,
      disabled: t2
    };
    $[0] = folderId;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    data: files
  } = useFiles(t3);
  const t4 = !!(resources && !resources.includes("flashcards"));
  let t5;
  if ($[3] !== folderId || $[4] !== t4) {
    t5 = {
      folderId,
      disabled: t4
    };
    $[3] = folderId;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    data: flashcardSets
  } = useFlashcardSets(t5);
  const t6 = !!(resources && !resources.includes("notes"));
  let t7;
  if ($[6] !== folderId || $[7] !== t6) {
    t7 = {
      folderId,
      disabled: t6
    };
    $[6] = folderId;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const {
    data: notes
  } = useNotes(t7);
  const t8 = !!(resources && !resources.includes("quizzes"));
  let t9;
  if ($[9] !== folderId || $[10] !== t8) {
    t9 = {
      folderId,
      disabled: t8
    };
    $[9] = folderId;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const {
    data: quizzes
  } = useQuizzes(t9);
  let t10;
  if ($[12] !== files || $[13] !== flashcardSets || $[14] !== notes || $[15] !== quizzes) {
    t10 = [...files.map(_temp), ...flashcardSets.map(_temp2), ...notes.map(_temp3), ...quizzes.map(_temp4)].sort(_temp5);
    $[12] = files;
    $[13] = flashcardSets;
    $[14] = notes;
    $[15] = quizzes;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const items = t10;
  let t11;
  if ($[17] !== items) {
    t11 = items.map(_temp6);
    $[17] = items;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <div className="workspace__content">{t11}</div>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
};
export const WorkspaceContentFallback = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="workspace__content" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(data) {
  return {
    type: "file" as const,
    data
  };
}
function _temp2(data_0) {
  return {
    type: "flashcards" as const,
    data: data_0
  };
}
function _temp3(data_1) {
  return {
    type: "note" as const,
    data: data_1
  };
}
function _temp4(data_2) {
  return {
    type: "quiz" as const,
    data: data_2
  };
}
function _temp5(a, b) {
  return new Date(b.data.meta.updatedAt).getTime() - new Date(a.data.meta.updatedAt).getTime();
}
function _temp6(props) {
  return <WorkspaceItem key={props.data.id} {...props} />;
}